var _sodipodiNamedview, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWishlist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "144.26826mm",
    height: "188.49954mm",
    viewBox: "0 0 144.26826 188.49954",
    id: "svg1",
    xmlSpace: "preserve",
    inkscapeVersion: "1.3.2 (091e20e, 2023-11-25)",
    sodipodiDocname: "drawing.svg",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview1",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    inkscapeShowpageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    inkscapeDeskcolor: "#d1d1d1",
    "inkscapeDocument-units": "mm",
    inkscapeZoom: 0.11425189,
    inkscapeCx: -1746.1417,
    inkscapeCy: 993.41898,
    "inkscapeWindow-width": 1366,
    "inkscapeWindow-height": 731,
    "inkscapeWindow-x": 0,
    "inkscapeWindow-y": 0,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "layer1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    inkscapeLabel: "Layer 1",
    inkscapeGroupmode: "layer",
    id: "layer1",
    transform: "translate(788.64736,133.08561)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#0d2c44",
      fillOpacity: 1
    },
    id: "g1",
    transform: "matrix(3.3072917,0,0,3.3072917,-822.34862,-144.66112)",
    "inkscapeExport-filename": "wishlist.svg",
    "inkscapeExport-xdpi": 96,
    "inkscapeExport-ydpi": 96
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "24 wishlist",
    id: "_24_wishlist",
    style: {
      fill: "#0d2c44",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 27.11,17.74 a 1,1 0 0 1 -1,1 h -9.32 a 1,1 0 0 1 0,-2 h 9.32 a 1,1 0 0 1 1,1 z",
    id: "path1",
    style: {
      fill: "#0d2c44",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 39.79,16.65 35.71,20 a 1.025,1.025 0 0 1 -0.64,0.23 0.948,0.948 0 0 1 -0.65,-0.25 l -2.78,-2.42 a 1,1 0 0 1 -0.1,-1.41 1.011,1.011 0 0 1 1.42,-0.1 l 2.13,1.87 3.44,-2.82 a 0.989,0.989 0 0 1 1.4,0.14 1,1 0 0 1 -0.14,1.41 z",
    id: "path2",
    style: {
      fill: "#a94064",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 27.11,27.06 a 1,1 0 0 1 -1,1 h -9.32 a 1,1 0 0 1 0,-2 h 9.32 a 1,1 0 0 1 1,1 z",
    id: "path3",
    style: {
      fill: "#0d2c44",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.79,25.97 -4.08,3.35 a 0.97,0.97 0 0 1 -0.64,0.23 0.948,0.948 0 0 1 -0.65,-0.25 l -2.78,-2.42 a 1,1 0 0 1 -0.1,-1.41 1.011,1.011 0 0 1 1.42,-0.1 l 2.13,1.87 3.44,-2.82 a 0.989,0.989 0 0 1 1.4,0.14 1,1 0 0 1 -0.14,1.41 z",
    id: "path4",
    style: {
      fill: "#a94064",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 27.11,36.38 a 1,1 0 0 1 -1,1 h -9.32 a 1,1 0 0 1 0,-2 h 9.32 a 1,1 0 0 1 1,1 z",
    id: "path5",
    style: {
      fill: "#0d2c44",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.79,35.29 -4.08,3.36 a 1.015,1.015 0 0 1 -0.64,0.22 0.987,0.987 0 0 1 -0.65,-0.24 L 31.64,36.2 a 1,1 0 0 1 -0.1,-1.41 1.01,1.01 0 0 1 1.42,-0.09 l 2.13,1.86 3.44,-2.82 a 1,1 0 0 1 1.26,1.55 z",
    id: "path6",
    style: {
      fill: "#a94064",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 27.11,45.7 a 1,1 0 0 1 -1,1 h -9.32 a 1,1 0 0 1 0,-2 h 9.32 a 1,1 0 0 1 1,1 z",
    id: "path7",
    style: {
      fill: "#0d2c44",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45.75,38.46 V 9.93 A 3.718,3.718 0 0 0 41.96,6.3 H 35.5 V 5.5 a 2.006,2.006 0 0 0 -2,-2 H 22.45 a 2.006,2.006 0 0 0 -2,2 v 0.8 h -6.46 a 3.727,3.727 0 0 0 -3.8,3.63 V 52.2 a 3.728,3.728 0 0 0 3.8,3.64 H 33.45 A 11.248,11.248 0 1 0 45.75,38.46 Z M 22.45,5.5 H 33.5 V 9.09 H 22.45 Z M 13.99,53.84 A 1.752,1.752 0 0 1 12.19,52.2 V 9.93 a 1.751,1.751 0 0 1 1.8,-1.63 h 6.46 v 0.79 a 2,2 0 0 0 2,2 H 33.5 a 2,2 0 0 0 2,-2 V 8.3 h 6.46 a 1.741,1.741 0 0 1 1.79,1.63 v 28.13 a 11.726,11.726 0 0 0 -1.2,-0.07 11.238,11.238 0 0 0 -10.26,15.85 z m 28.56,4.66 a 9.255,9.255 0 1 1 9.26,-9.25 9.261,9.261 0 0 1 -9.26,9.25 z",
    id: "path8",
    style: {
      fill: "#0d2c44",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 49.52,46.61 C 49.51,46.5 49.49,46.4 49.47,46.29 a 3.519,3.519 0 0 0 -3.48,-2.94 h -0.02 a 5,5 0 0 0 -3.42,1.46 4.963,4.963 0 0 0 -3.42,-1.46 H 39.12 A 3.326,3.326 0 0 0 38.16,43.5 0.749,0.749 0 0 0 38,43.54 3.5,3.5 0 0 0 35.99,45.27 c -0.01,0.03 -0.02,0.05 -0.03,0.08 a 3.682,3.682 0 0 0 -0.33,0.95 c -0.02,0.1 -0.03,0.2 -0.05,0.31 -0.65,4.9 4.37,8.58 5.89,9.57 l 0.51,0.35 a 0.931,0.931 0 0 0 0.57,0.19 0.959,0.959 0 0 0 0.58,-0.19 L 43.6,56.2 c 1.55,-1.01 6.57,-4.69 5.92,-9.59 z m -6.97,7.89 c -2.67,-1.76 -5.38,-4.67 -4.98,-7.63 l 0.03,-0.21 a 1.526,1.526 0 0 1 1.52,-1.31 3.026,3.026 0 0 1 2.54,1.58 1.039,1.039 0 0 0 1.78,0 3.039,3.039 0 0 1 2.54,-1.58 1.518,1.518 0 0 1 1.52,1.3 l 0.04,0.22 c 0.39,2.95 -2.29,5.85 -4.99,7.63 z",
    id: "path9",
    style: {
      fill: "#a94064",
      fillOpacity: 1
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlist);
export default __webpack_public_path__ + "static/media/wishlist.ccd1ba72095a4be41f5aaa980ab44c1f.svg";
export { ForwardRef as ReactComponent };